import { Link } from "react-router-dom";
import { categoryList } from "@/utils/articles";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-100 border-t border-background-200">
      <div className="max-w-portal mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-md bg-primary-600 text-background-50 flex items-center justify-center font-label font-bold text-lg">
                51
              </span>
              <div>
                <p className="font-heading text-lg font-black text-foreground-950">51黑料网</p>
                <p className="text-[11px] font-label tracking-[0.18em] text-foreground-500">
                  AUTHORITATIVE EXPOSURE PORTAL
                </p>
              </div>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              51黑料网是一个聚焦明星、娱乐与社会热点的爆料资讯门户。我们坚持“先核实、再发布”的原则，
              用时间线、背景资料与多方回应，帮你在信息洪流里看清一件事的来龙去脉。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="text-xs text-foreground-500">线索邮箱</span>
              <a
                href="mailto:tip@51heiliao.example"
                className="text-sm text-primary-700 hover:text-primary-600 transition-colors"
              >
                tip@51heiliao.example
              </a>
            </div>
          </div>

          <div>
            <p className="font-heading text-sm font-bold text-foreground-950 mb-4">内容分类</p>
            <ul className="space-y-3 text-sm text-foreground-600">
              {categoryList.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="hover:text-primary-600 transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/search" className="hover:text-primary-600 transition-colors">
                  全站搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-heading text-sm font-bold text-foreground-950 mb-4">关于与帮助</p>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li>
                <Link to="/about" className="hover:text-primary-600 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-primary-600 transition-colors">
                  联系与投稿
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary-600 transition-colors">
                  内容准则
                </Link>
              </li>
              <li>
                <span className="text-foreground-500">微博 / 微信公众号（演示）</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60">
          <p className="text-xs leading-relaxed text-foreground-500">
            免责声明：本站为产品演示站点，站内所有人物、事件、评论与图片均为虚构创作，不对应任何现实中的个人或机构，
            如有雷同纯属巧合。站内收藏、浏览记录等互动仅保存在你的浏览器本地，未接入任何后台服务。
          </p>
          <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-foreground-500">
            <p>© 2026 51黑料网 · 权威爆料资讯平台</p>
            <p className="font-label tracking-wide">内容演示版本 · 请理性吃瓜</p>
          </div>
        </div>
      </div>
    </footer>
  );
}